import { AfterViewInit, Component, EventEmitter, inject, Input, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { InputComponent } from 'src/app/shared/components/validation/validations.component';
import { SignupService } from '../../service/signup.service';
import { firstValueFrom } from 'rxjs';
import { FormNavigationButtonsComponent } from '../components/form-navigation-buttons/form-navigation-buttons.component';

@Component({
  selector: 'app-auth-code',
  templateUrl: './auth-code.component.html',
  styleUrls: ['./auth-code.component.scss']
})
export class AuthCodeComponent implements AfterViewInit{
  @Input() userProfile: any;
  @Output() userProfileChange = new EventEmitter<any>();
  @ViewChild('authCodeForm') authCodeForm!: NgForm;
  @ViewChild(InputComponent) inputComponent!: InputComponent;
  @ViewChild(FormNavigationButtonsComponent) formNavComponent!: FormNavigationButtonsComponent;
  childNavMethodNext = async()=>{}
  signupService = inject(SignupService)

  ngAfterViewInit(): void {
    this.inputComponent.hideLabel();
    this.childNavMethodNext = this.formNavComponent?.handleContinueClick
    this.formNavComponent!.handleContinueClick = async () => {
      const isValid = await this.ValidateAuthCode()
      if(isValid){
        this.formNavComponent!.handleContinueClick = this.childNavMethodNext
        this.formNavComponent!.handleContinueClick()
      }
    }
  }

  async ValidateAuthCode():Promise<boolean>{
    if(!this.userProfile.authCode) return false
    const isValid = await firstValueFrom(this.signupService.validateSignupAuthCode(this.userProfile.authCode))
    if(!isValid)
      this.authCodeForm.controls['authCode'].setErrors({pattern:'invalid auth code'})
    return isValid
  }

  onContinue():void{
    this.userProfileChange.emit(this.userProfile)
  }
}
